import React, { useEffect, useState } from 'react';
import { Box, Typography } from '@mui/material';
import { getConsolidatedTimings } from '../../../services/TimingService';
import { msToTime } from '../../../utils/TimeConversionFunctions';
import { useStyles } from './InternalStyle';
import { OPTIONS } from '../TilesConstants';
import moment from 'moment';

function TimingsDetail(props) {
  const classes = useStyles();
  const userDetails = props.userDetails;
  const [startDate, setStartDate] = useState(
    new Date(
      new Date().getFullYear(),
      new Date().getMonth(),
      new Date().getDate() + 1,
    )
      .toISOString()
      .slice(0, 10),
  );
  const [officeHrs, setOfficeHrs] = useState();
  const [breaks, setBreaks] = useState();

  function formatDate(date) {
    const options = OPTIONS;
    return date.toLocaleString('en-US', options);
  }

  const loadTodayConsolidatedData = async (empId, startDate, endDate) => {
    let consolidateData = await getConsolidatedTimings(
      empId,
      startDate,
      endDate,
    );
    if (
      consolidateData.isError === false &&
      consolidateData.data.content.length > 0
    ) {
      setOfficeHrs(msToTime(consolidateData.data.content[0]['officeHrs']));
      setBreaks(msToTime(consolidateData.data.content[0]['breaks']));
    }
  };

  useEffect(() => {
    if (userDetails.id !== undefined)
      loadTodayConsolidatedData(userDetails.id, startDate, startDate);
  }, [userDetails.id]);

  return (
    <>
      <Box className={classes.boxFeature}>
        <Typography variant="h7" sx={{ alignSelf: 'flex-start' }}>
          Today
        </Typography>
        <Typography
          variant="h7"
          sx={{ textAlign: 'end', alignSelf: 'flex-start' }}
        >
          {moment(new Date()).format('dddd MMMM D, YYYY')}
        </Typography>
      </Box>
      <Box className={classes.boxFeature}>
        <Typography variant="h7" sx={{ alignSelf: 'flex-start' }}>
          Clocked Time
        </Typography>
        <Typography variant="h7" sx={{ alignSelf: 'flex-start' }}>
          {officeHrs}
        </Typography>
      </Box>
      <Box className={classes.boxFeature}>
        <Typography variant="h7" sx={{ alignSelf: 'flex-start' }}>
          Break Time
        </Typography>
        <Typography variant="h7" sx={{ alignSelf: 'flex-start' }}>
          {breaks}
        </Typography>
      </Box>
    </>
  );
}

export default TimingsDetail;
